<style>
.tags-input {
  background: white;
  border: 1px solid #dadada;
  border-radius: 5px;
  color: black;
  display: flex;
  flex-wrap: wrap;
  padding: 0.2em;
}

.tags-input.remove-only {
  border-color: rgba(0, 0, 0, 0.2);
}

.tags-input .input-tag {
  color: #fff;
  background-color: #ed572f;
  border-radius: 4px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-right: 8px;
}

.tags-input .input-tag .remove {
  cursor: pointer;
  color: #fff;
  padding: 8px;
}

.tags-input .input-tag .remove::before {
  content: '×';
}

.tags-input .input-tag .remove:hover {
  opacity: 1;
  text-decoration: none; /* Override global link style. */
}

.input.new-tag:focus {
  outline: none;
}

.tags-input .new-tag {
  background: transparent;
  border: 0;
  box-shadow: none;
  color: inherit;
  flex: 1;
  font: inherit;
  padding: 0.1em;
  margin: 0.2em;
}
</style>

<template>
  <InputTag
    :class="`tags-input ${removeOnly ? 'remove-only' : ''}`"
    :value="valueAsArray"
    :placeholder="removeOnly ? '' : placeholder"
    :read-only="readOnly"
    @input="handleChange"
    @hook:updated="removeDefaultClassName"
  ></InputTag>
</template>

<script>
import InputTag from 'vue-input-tag';

export default {
  components: {
    InputTag,
  },

  props: {
    value: [Array, String],
    placeholder: String,
    readOnly: Boolean,
    removeOnly: Boolean,
  },

  computed: {
    valueAsArray() {
      if (Array.isArray(this.value)) {
        return [...this.value];
      } else {
        return this.value
          .trim()
          .split(/\s*,\s*/)
          .filter(Boolean);
      }
    },
  },

  methods: {
    removeDefaultClassName() {
      this.$el.classList.remove('vue-input-tag-wrapper');
    },

    handleChange(newValue) {
      const formattedValue = Array.isArray(this.value) ? newValue : newValue.join(',');
      this.$emit('input', formattedValue);
    },
  },

  mounted() {
    this.removeDefaultClassName();
  },

  updated() {
    this.removeDefaultClassName();
  },

  watch: {
    removeOnly: {
      async handler(removeOnly) {
        await this.$nextTick();
        this.$el.querySelector('input').disabled = removeOnly;
      },
      immediate: true,
    },
  },
};
</script>
